export default "__VITE_PUBLIC_ASSET__533514e7__"